import React from 'react';
import Icon from '../../../components/AppIcon';

const PlatformCard = ({ platform, icon, accentColor, stats, badge, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-xl border border-[#E5E7EB] shadow-sm overflow-hidden animate-pulse">
        <div className="h-1 w-full" style={{ backgroundColor: accentColor, opacity: 0.3 }} />
        <div className="p-5">
          <div className="flex items-center gap-2.5 mb-4">
            <div className="w-8 h-8 rounded-lg bg-slate-100" />
            <div className="h-4 bg-slate-100 rounded w-24" />
          </div>
          <div className="grid grid-cols-2 gap-x-4 gap-y-4">
            {[1, 2, 3, 4].map(i => (
              <div key={i}>
                <div className="h-5 bg-slate-100 rounded w-10 mb-1" />
                <div className="h-3 bg-slate-100 rounded w-20" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-[#E5E7EB] shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-200 group">
      {/* Top accent line */}
      <div className="h-[3px] w-full" style={{ backgroundColor: accentColor }} />

      <div className="p-5">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2.5">
            <div
              className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: `${accentColor}15` }}
            >
              <Icon name={icon} size={15} style={{ color: accentColor }} />
            </div>
            <span className="text-sm font-semibold text-[#0F172A]">{platform}</span>
          </div>
          {badge && (
            <span
              className="text-[10px] font-semibold px-2 py-0.5 rounded-full border"
              style={{ color: badge.color, backgroundColor: badge.bg, borderColor: `${badge.color}30` }}
            >
              {badge.label}
            </span>
          )}
        </div>

        {/* Stats 2×2 grid */}
        <div className="grid grid-cols-2 gap-x-4 gap-y-3">
          {stats.map((stat, i) => (
            <div key={i}>
              <p className="text-lg font-bold text-[#0F172A] leading-none mb-0.5">
                {stat.value ?? <span className="text-sm text-[#94A3B8]">—</span>}
              </p>
              <p className="text-[11px] text-[#64748B] leading-tight">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlatformCard;
